import { types } from "../Helpers/Types";

const initialState = {
  clienteinput: "",
  clienteselected: "",
  idcliente: "",
  clientesArray: [],
  disabled: true,
};

export const ClientesearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.clienteinput: {
      return {
        ...state,
        clienteinput: action.payload,
      };
    }
    case types.clientes: {
      return {
        clienteinput: action.payload.clienteinput,
        clienteselected: action.payload.clienteselected,
        idcliente: action.payload.idcliente,
        clientesArray: action.payload.clientesArray,
        disabled: action.payload.disabled,
      };
    }
    case types.clienteselected: {
      return {
        ...state,
        clienteselected: action.payload,
      };
    }
    case types.idcliente: {
      return {
        ...state,
        idcliente: action.payload,
      };
    }
    case types.clientesArray: {
      return {
        ...state,
        clientesArray: action.payload,
      };
    }
    case types.disabled: {
      return {
        ...state,
        disabled: action.payload,
      };
    }

    default:
      return state;
  }
};
